import { format } from 'date-fns'
import type { Filters } from 'hooks/store/service-orders';
import type { FormSchema } from './form-schema';

const f = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};

type CreateFilterParamsProps = {
  formData: FormSchema;
  currentStatus?: string[];
}

export const createFilterParams = ({ currentStatus, formData }: CreateFilterParamsProps): Filters => {
  const {
    startDate,
    endDate,
    createdAt,
    ...rest
  } = formData;

  return {
    currentStatus,
    ...rest,
    ...(startDate && { startDate: f(startDate) }),
    ...(endDate && { endDate: f(endDate) }),
    ...(createdAt?.from && { createdAtFrom: f(createdAt.from) }),
    ...(createdAt?.to && { createdAtTo: f(createdAt.to) }),
  }
}